import GlobalContext from '../context/GlobalContext'
import { useContext } from 'react'
import { AuthorizationGroupDto } from '../components/Combobox/AuthorizationGroupCombobox'

export default function useAuthorizationGroups(): AuthorizationGroupDto[] {
    const { authorizationGroups } = useContext(GlobalContext)
    return authorizationGroups
}
